export const jobAppCountFilterAdapter = {
  vendor: {
    path: 'job_app',
    field: 'job_app_vendor_system_id'
  },
  business_unit: {
    field: 'org_unit_name',
    path: 'job_app__job'
  },
  location: {
    field: 'job_ws_name',
    path: 'job_app__job'
  },
  resource_manager: {
    field: 'job_resource_manager_name',
    path: 'job_app__job'
  },
  invoice_status: {
    field: 'line_item_status',
    path: 'job_app__work_order__invoice_details'
  },
  billing_cycle_end_date_from: {
    field: 'invoice_billing_cycle_end_date',
    path: 'job_app__work_order__invoice_details'
  },
  billing_cycle_end_date_to: {
    field: 'invoice_billing_cycle_end_date',
    path: 'job_app__work_order__invoice_details'
  }
}

export const jobsFilterAdapter = {
  job_status: {
    field: 'job_status',
    path: 'job'
  },
  job_category: {
    field: 'job_category',
    path: 'job'
  },
  job_title: {
    field: 'job_title',
    path: 'job'
  },
  org_unit: {
    field: 'org_unit_name',
    path: 'job'
  },
  resource_manager: {
    field: 'job_resource_manager_name',
    path: 'job'
  },
  worksite: {
    field: 'job_ws_name',
    path: 'job'
  },
  module: {
    field: 'module',
    path: 'job'
  },
  program_team_entity: {
    field: 'program_team_entity_id',
    path: 'job'
  }
}
